import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../auth";
import api from "../api";

export default function History() {
  const { me } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const [rows,    setRows]    = useState([]);
  const [total,   setTotal]   = useState(0);
  const [loading, setLoading] = useState(true);
  const [empList, setEmpList] = useState([]);
  const [selEmp,  setSelEmp]  = useState(searchParams.get("emp")||"");
  const [photoModal, setPhotoModal] = useState(null); // {url, time}
  // Admin sees all; HR sees non-admin employees; Manager sees reportees; team_member: no dropdown
  const isAdmin = me?.role==="admin"||me?.role==="hr"||me?.role==="manager";  // show dropdown

  useEffect(() => {
    if (!isAdmin) return;
    if(isAdmin) api.get("/portal/team").then(d=>setEmpList(d.members||[])).catch(()=>{});
  }, [isAdmin]);

  useEffect(() => {
    const emp=searchParams.get("emp"); if(emp) setSelEmp(emp);
  }, [searchParams]);

  useEffect(() => {
    setLoading(true);
    const empParam = selEmp && selEmp!==me?.employee_id ? `&emp=${selEmp}` : "";
    api.get(`/portal/history?limit=200${empParam}`)
      .then(d=>{setRows(d.items||[]);setTotal(d.total||0);})
      .catch(()=>{}).finally(()=>setLoading(false));
  }, [selEmp, me?.employee_id]);

  const viewPhoto = async (logId, time) => {
    try {
      const resp = await fetch(`/api/portal/history_photo/${logId}`, {
        headers:{Authorization:`Bearer ${sessionStorage.getItem("iws_token")}`}
      });
      if (!resp.ok) { alert("No photo available."); return; }
      const blob = await resp.blob();
      setPhotoModal({url:URL.createObjectURL(blob), time});
    } catch { alert("Could not load photo."); }
  };

  return (
    <div>
      <h2 className="page-title">History</h2>
      <p className="page-sub">All face check-in attempts — successes and failures, with captured photo.</p>

      {/* Employee selector (admin) */}
      {isAdmin && (
        <div style={{display:"flex",alignItems:"center",gap:8,margin:"12px 0"}}>
          <label style={{fontSize:13,color:"var(--muted)",margin:0}}>Employee:</label>
          <select className="inp" style={{width:"auto",minWidth:200}} value={selEmp}
            onChange={e=>{setSelEmp(e.target.value);setSearchParams(e.target.value?{emp:e.target.value}:{});}}>
            <option value="">Myself ({me?.name} - {me?.employee_id})</option>
            {empList.map(e=><option key={e.employee_id} value={e.employee_id}>{e.name} ({e.employee_id})</option>)}
          </select>
        </div>
      )}

      {total>0&&<p style={{fontSize:13,color:"var(--muted)",margin:"12px 0"}}>Showing {rows.length} of {total} attempts</p>}

      <div className="card" style={{marginTop:16,overflowX:"auto"}}>
        {loading?<div className="loading">Loading…</div>:(
          <table className="tbl">
            <thead><tr>
              {["Time","Source","Action","Result","Conf.","Attendance","Location","Photo"].map(h=><th key={h}>{h}</th>)}
            </tr></thead>
            <tbody>
              {rows.map(r=>(
                <tr key={r.id}>
                  <td style={{whiteSpace:"nowrap",fontSize:13}}>{r.time}</td>
                  <td style={{fontSize:13}}>{r.source}</td>
                  <td>{r.action==="checkin"?"Check-in":"Check-out"}</td>
                  <td><span className={`pill ${r.result==="Success"?"green":"red"}`}>{r.result}</span></td>
                  <td>{r.confidence?`${r.confidence}%`:"—"}</td>
                  <td>{r.attendance?<span className="pill green">Recorded</span>:<span style={{color:"var(--muted)"}}>—</span>}</td>
                  <td>{r.lat?<a href={`https://maps.google.com/?q=${r.lat},${r.lng}`} target="_blank"
                    rel="noreferrer" style={{color:"var(--accent)"}}>map</a>:"—"}</td>
                  <td>{r.photo
                    ?<button onClick={()=>viewPhoto(r.id,r.time)}
                      style={{background:"none",border:"1px solid var(--line)",borderRadius:6,
                        padding:"3px 10px",cursor:"pointer",fontSize:12}}>View</button>
                    :"—"}</td>
                </tr>
              ))}
              {!rows.length&&<tr><td colSpan={8} style={{textAlign:"center",color:"var(--muted)"}}>No attempts yet.</td></tr>}
            </tbody>
          </table>
        )}
      </div>

      {/* Photo modal */}
      {photoModal&&(
        <div onClick={()=>{URL.revokeObjectURL(photoModal.url);setPhotoModal(null);}}
          style={{position:"fixed",inset:0,background:"rgba(0,0,0,.75)",zIndex:9999,
            display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",
            cursor:"pointer"}}>
          <div style={{background:"#fff",borderRadius:12,overflow:"hidden",maxWidth:480,width:"95%"}}>
            <div style={{padding:"12px 16px",borderBottom:"1px solid var(--line)",
              display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span style={{fontSize:13,color:"var(--muted)"}}>{photoModal.time}</span>
              <button onClick={()=>{URL.revokeObjectURL(photoModal.url);setPhotoModal(null);}}
                style={{background:"none",border:"none",fontSize:22,cursor:"pointer",color:"#999"}}>×</button>
            </div>
            <img src={photoModal.url} alt="capture"
              style={{width:"100%",display:"block"}} onClick={e=>e.stopPropagation()}/>
          </div>
        </div>
      )}
    </div>
  );
}
